import React from 'react';
import _ from 'lodash';
import moment from 'moment';

export function getFieldName(name) {
  switch (name) {
    case 'patientName':
      return 'Potilaan nimi';
    case 'reason':
      return 'Kuljetuksen syy';
    case 'fromUnit':
      return 'Lähtöpiste';
    case 'fromOrganization':
      return 'Lähtöpiste';
    case 'fromRoom':
      return '';
    case 'toUnit':
      return 'Päätepiste';
    case 'toOrganization':
      return 'Päätepiste';
    case 'toRoom':
      return '';
    case 'equipment':
      return 'Kuljetusväline';
    case 'time':
      return 'Perilläoloaika';
    case 'remarks':
      return 'Lisätietoja';
    case 'oxygen':
      return 'Lisähappi';
    case 'cane':
      return 'Keppi';
    case 'dog':
      return 'Opaskoira';
    case 'escort':
      return 'Saattaja';
    case 'space':
      return 'Korjattava tila';
    case 'deliveryAddress':
      return 'Toimitusosoite';
    case 'type':
      return 'Korjauksen tyyppi';
    case 'description':
      return 'Palvelupyyntö';
    case 'infectionRisk':
      return 'Tartuntavaara';
    case 'othersHaveSameProblem':
      return 'Muillakin on sama ongelma';
    case 'personalGuidance':
      return 'Toivon henkilökohtaista opastusta järjestelmän käyttöön';
    case 'mayCall':
      return 'puhelimitse';
    case 'mayText':
      return 'tekstiviestitse';
    case 'mayEmail':
      return 'sähköpostilla';
    case 'collectFeedback':
      return 'Haluan saada tiedon tilauksen valmistumisesta sähköpostiini.';
    case 'gasbottles':
      return 'Pullotyypit';
    case 'additionalInfo':
      return 'Palvelupyyntö';
    case 'contactPhone':
      return 'Puhelinnumero';
    case 'isUrgent':
      return 'Kiirellinen';
    case 'accuracy':
      return 'Perilläoloajan tarkkuus';
    case 'locationText':
      return 'Paikka';
    case 'informationText':
      return 'Kuvaus';
    case 'pickupOnCall':
      return 'Leikkausjonossa';
    case 'dropletPrecautions':
      return 'Pisaraeristys';
    case 'bloodPrecautions':
      return 'Verieristys';
    case 'contactPrecautions':
      return 'Kosketuseristys';
    case 'airbornePrecautions':
      return 'Ilmaeristys';
    default:
      return name;
  }
}

export function getFieldPlaceholder(name) {
  switch (name) {
    case 'patientName':
      return 'Nimi';
    case 'reason':
      return 'esim.kuljetus radiologiaan';
    case 'fromUnit':
      return 'Yksikkö';
    case 'fromRoom':
      return 'Tarkka sijainti';
    case 'toUnit':
      return 'Yksikkö';
    case 'toRoom':
      return 'Tarkka sijainti';
    case 'space':
      return 'Tilan tunniste';
    case 'description':
      return 'Tarkennukset, lisähuomiot ym.';
    case 'contactPhone':
      return 'Yhteyshenkilön puhelinnumero.';
    default:
      return '';
  }
}

export function getTaskListLabel(name) {
  switch (name) {
    case 'patientName':
      return 'Potilaan nimi';
    case 'reason':
      return 'Kuljetuksen syy';
    case 'fromUnit':
      return 'Lähtöpiste yksikkö';
    case 'function':
      return 'Toiminto';
    case 'project':
      return 'Hanke';
    case 'fromSpace':
      return 'Lähtöpiste';
    case 'fromRoom':
      return 'Lähtöpiste huone';
    case 'pickupRoom':
      return 'Nouto huoneesta';
    case 'pickupAddress':
      return 'Nouto osoitteesta';
    case 'toUnit':
      return 'Päätepiste yksikkö';
    case 'toSpace':
      return 'Päätepiste';
    case 'toRoom':
      return 'Päätepiste huone';
    case 'equipment':
      return 'Kuljetusväline';
    case 'time':
      return 'Perilläoloaika';
    case 'from':
      return 'Lähtöpiste';
    case 'to':
      return 'Päätepiste';
    case 'fromOrganization':
      return 'Lähtöpiste';
    case 'toOrganization':
      return 'Päätepiste';
    case 'oxygen':
      return 'Lisähappi';
    case 'remarks':
      return 'Lisätietoja';
    case 'space':
      return 'Korjattava tila';
    case 'description':
      return 'Tarkennukset, lisähuomiot ym';
    case 'type':
      return 'Korjauksen tyyppi';
    case 'infectionRisk':
      return 'Tartuntavaara';
    case 'isUrgent':
      return 'Kiirellinen';
    case 'collectFeedback':
      return 'Tieto valmistumisesta';
    case 'deliveryAddress':
      return 'Toimitusosoite';
    case 'gasbottles':
      return 'Kaasupullot';
    case 'additionalInfo':
      return 'Lisätietoja';
    case 'contactPhone':
      return 'Puhelinnumero';
    case 'accuracy':
      return 'Perilläoloajan tarkkuus';
    case 'identificationNumber':
      return 'Laitteen tunnusnumero';
    case 'deviceUnit':
      return 'Laitteen toimipiste';
    case 'deviceLocation':
      return 'Laitteen tarkempi sijainti';
    case 'maintenanceUnit':
      return 'Huoltoyksikkö';
    case 'accountNumber':
      return 'Liittymän numero';
    case 'accountUnit':
      return 'Liittymän haltijan toimipiste';
    case 'pickupOnCall':
      return 'Potilas on leikkausjonossa';
    case 'dropletPrecautions':
      return 'Pisaraeristys';
    case 'contactPrecautions':
      return 'Kosketuseristys';
    case 'airbornePrecautions':
      return 'Ilmaeristys';
    case 'locationText':
      return 'Paikka';
    case 'informationText':
      return 'Kuvaus';
    case 'code':
      return 'Pullokoodi';
    case 'wasteType':
      return 'Jätetyyppi';
    case 'pickupOrganization':
      return 'Yksikkö';
    case 'scheduleType':
      return 'Toimitusajankohta';
    case 'payerOrganization':
      return 'Maksajaosasto';
    case 'transportType':
      return 'Kuljetustapa';
    case 'packageType':
      return 'Kuljetettava tavara';
    case 'fromAddress':
      return 'Lähtöpiste osoite';
    case 'toAddress':
      return 'Päätepiste osoite';
    case 'earliestTime':
      return 'Aikaisintaan';
    case 'latestTime':
      return 'Viimeistään';
    default:
      return name;
  }
}

export function getStatusText(txt) {
  switch (txt) {
    case 'ORDERED':
      return 'Hyväksyttävät tilaukset';
    case 'APPROVED,ACKNOWLEDGED':
      return 'Aktiiviset tilaukset';
    case 'IN_PROGRESS':
      return 'Toimituksessa olevat tilaukset';
    case 'COMPLETED':
      return 'Valmiit tilaukset';
    case 'CANCELED':
      return 'Peruutetut tilaukset';
    case 'ASSIGNED':
      return 'Varatut tilaukset';
    case 'FAILED':
      return 'Epäonnistuneet tilaukset';
    default:
      console.debug(
        'getStatusText: Unknown status. Check form.utils.js: ',
        txt
      );
      return txt;
  }
}

export function getOptionText(optionName) {
  switch (optionName) {
    case 'WHEELCHAIR':
      return 'Pyörätuoli';
    case 'WHEELCHAIR_PORTER':
      return 'Pyörätuoli, kuljettaja tuo';
    case 'BED':
      return 'Sänky';
    case 'SAHKO':
      return 'Sähkötyö';
    case 'RAKENNE':
      return 'Rakenteen korjaus';
    case 'LVI':
      return 'LVI';
    case 'ULKO':
      return 'Ulkoalue';
    case 'JATETURVA':
      return 'Turva';
    case 'KAASUT':
      return 'Kaasut';
    case 'OPASTEET':
      return 'Opasteet';
    case 'TEKNISETPIIRUSTUKSET':
      return 'Tekniset piirustukset';
    case 'TARKKA':
      return 'Tarkka tavoiteaika';
    case 'JOUSTAVA':
      return 'Aika on joustava';
    case 'SOITOSTA':
      return 'Leikkausjonossa';
    default:
      return optionName;
  }
}

// For history basically
export function getStatus(txt) {
  switch (txt) {
    case 'ORDERED':
      return 'Tilaus luotu';
    case 'APPROVED':
      return 'Tilaus hyväksytty';
    case 'ACKNOWLEDGED':
      return 'Kuitattu';
    case 'IN_PROGRESS':
      return 'Käynnissä';
    case 'DELIVERED':
      return 'Kuljetettu';
    case 'COMPLETED':
      return 'Valmis';
    case 'CANCELED':
      return 'Peruttu';
    case 'DELEGATED':
      return 'Välitetty';
    case 'ASSIGNED':
      return 'Varattu';
    case 'FAILED':
      return 'Epäonnistunut';
    default:
      return txt;
  }
}

const getItemLabel = (field, item) => {
  // item is an id
  const res = _.find(field.options, option => option.value === item);
  if (res && res.text) {
    return res.text;
  }
  return item;
};

export function getFieldValue(value, type, dataDependencies = {}) {
  const { field } = dataDependencies;
  const defaultValue = value || '-';

  if (!value) {
    // Even if a boolean field has the value null it will be rendered
    if (type === 'FIELD_TYPE_BOOLEAN') return 'Ei';
    return defaultValue;
  }

  switch (type) {
    case 'FIELD_TYPE_STRING':
      return value;
    case 'FIELD_TYPE_TEXT':
      return value;
    case 'FIELD_TYPE_BOOLEAN': {
      // The 'Ei' option is already exhausted above
      return 'Kyllä';
    }
    case 'FIELD_TYPE_DATE':
      return moment(value).format('DD.MM.YYYY, HH:mm');
    case 'FIELD_TYPE_LIST':
      return getItemLabel(field, value);
    case 'FIELD_TYPE_TAGS':
      return getItemLabel(field, value);
    case 'FIELD_TYPE_SPACE': {
      const space = value;
      const nickname =
        space.nickname && space.nickname !== '' ? space.nickname : space.usage;

      if (!space || !space.building) {
        return 'Ei tiedossa';
      }

      if (!space.room) {
        return `${space.floor}/${space.building}`;
      }

      return `${space.floor}.${space.room}/${space.building} ${nickname}`;
    }
    case 'FIELD_TYPE_VALUESET': {
      return (
        <ul>
          {value.map(item => (
            <li key={item.id}>{`${item.title}, ${item.itemCount} kpl`}</li>
          ))}
        </ul>
      );
    }
    case 'FIELD_TYPE_UNIT': {
      // NOTE: Organization value is 0 if "Muu, mikä"
      // is selected in patient transportation form
      if (value === '0') return 'Muu';

      let orgName = value;
      if (dataDependencies.organizations) {
        const org = _.find(
          dataDependencies.organizations,
          org => Number(org.id) === Number(value)
        );
        orgName = org ? org.name : value;
      }

      return orgName;
    }
    default:
      return defaultValue;
  }
}

export const populateFormFromOrder = (setValues, fields) => {
  setValues({ ...fields });
};
